module.exports = __webpack_public_path__ + "media/Q7.6059cd5e.mp4";